<template lang="pug">
	
	.pro-era-presentation
		
		.container

			.pro-era-text
				.text-part-1
					p.text(v-html="translate('pro_era.text_1')")
						
				.text-part-2
					p.text(v-html="translate('pro_era.text_2')") Ce dernier s’étant ôté la vie à l’âge de 19 ans un 24 décembre 2012 pendant l’ascension du label, le crew connaîtra une triste période de deuil et rendra multiples hommages à leur ami décédé. 
				
			.wrap-image.image-1
				responsive-image(:src="shoesImg" width="432" height="325")
			
			.wrap-image.image-2
				responsive-image(:src="joeyImg" width="793" height="528")


</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import { TweenMax } from 'gsap'
	import Globals from '~utils/Globals.js'
	import Scrollable from '~abstracts/scrollable'
	import ResponsiveImage from '~components/responsive-image.vue'

	import ProShoes from 'assets/images/pro-era-shoes.jpg'
	import ProJoey from 'assets/images/pro-era-joey.jpg'

  	@Component({
		name: 'ProEraPresentation',
		components: {ResponsiveImage},
		data: function () {
			return {
				state : Globals.state,
				shoesImg: ProShoes,
				joeyImg: ProJoey
			}
		},
		computed : {
			isMobile: function () {
				return this.state.isMobile
			},
			isTablet: function () {
				return this.state.isTablet
			}
		}
	})

	class ProEraPresentation extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$image1 = this.$el.querySelector('.image-1')
			this.$image2 = this.$el.querySelector('.image-2')
		}


		initTimeline () {
			super.initTimeline()

			this.tl.fromTo(this.$image1,1,
				{y:Globals.responsiveHeight(-200)},
				{y:Globals.responsiveHeight(200)},
			0)
			this.tl.fromTo(this.$image2,1,
				{y:Globals.responsiveHeight(100)},
				{y:Globals.responsiveHeight(-150)},
			0)			
		}

		raf (y) {
			super.raf(y)	
		}

		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height + window.innerHeight
			}

			this.initTimeline ()

		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default ProEraPresentation

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.pro-era-presentation
		width 100%
		padding-bottom 25%
		position relative
		padding-top 50px

		.pro-era-text
			width 100%
			display flex
			position relative
			z-index 40
			
			+break(xs)
				flex-wrap wrap

				.mobile-image
					width 100%
					margin 20px 0

			.text-part-1
				width 20%
				margin-left 30%

			.text-part-2
				width 20%
				margin-left 5%
				margin-top 90px

			[class^="text-part"]
				+break(xs)
					width 100%
					margin 0

			.text
				font-size em(15px)
				line-height em(24px,15px)
				color #fff
				font-family $FONT_THIRDLY
				width 100%

				span,a
					font-family $FONT_PRIMARY
					color #e94646
					text-decoration underline 

		.wrap-image
			position absolute
			z-index 30

			img
				width 100%

			&.image-1
				left 5%
				top 170px
				width 30%

			&.image-2
				top 360px
				left 40%
				width 50%
	
</style>


// WEBPACK FOOTER //
// pro-era-presentation.vue?1f0c648e